import React from "react";
import { Bone, Skeleton } from "@xo-union/tk-ui-skeleton";
var Loading = function Loading(_ref) {
  var isMobile = _ref.isMobile;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Skeleton, {
    style: {
      width: "100%",
      height: isMobile ? "auto" : "100%"
    },
    "aria-label": "Loading designer card"
  }, /*#__PURE__*/React.createElement(Bone, {
    style: {
      height: isMobile ? 239 : 435,
      width: "100%",
      marginBottom: 20,
      borderRadius: "4px"
    }
  }), /*#__PURE__*/React.createElement(Bone, {
    style: {
      height: 20,
      width: "100%",
      marginBottom: 10,
      borderRadius: "4px"
    }
  }), /*#__PURE__*/React.createElement(Bone, {
    style: {
      height: 20,
      width: "50%",
      marginBottom: 10,
      borderRadius: "4px"
    }
  })));
};
export default Loading;